import { render, staticRenderFns } from "./AddSuppliesInventory.vue?vue&type=template&id=5a0a8efa"
import script from "./AddSuppliesInventory.vue?vue&type=script&lang=js"
export * from "./AddSuppliesInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports